import { Post } from "@/constants/types";
import { limitText } from "@/utils";
import Link from "next/link";
import React from "react";

const DomaineCard = ({ domaine }: { domaine?: Post }) => {
  return (
    <div className="swiper-slide">
      <div className="tp-mission-2__item">
        <div
          className="tp-mission-2__single-bg"
          data-background="assets/img/mission/mission-bg.png"
        ></div>
        <div className="tp-mission-2__icon">
          <span>
            <i className="flaticon-drops"></i>
          </span>
        </div>
        <div className="tp-mission-2__text">
          <Link href={`/area/${domaine?.slug}`}>
            <h4 className="tp-mission-2__title-sm">
              {limitText(domaine?.title, 20)}
            </h4>
          </Link>
          <div
            dangerouslySetInnerHTML={{
              __html: limitText(domaine?.content, 90),
            }}
          ></div>
        </div>
        <div className="tp-mission-2__shape-box">
          <Link href={`/area/${domaine?.slug}`} className="tp-mission-2__arrow">
            <i className="fa-light fa-arrow-right-long"></i>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DomaineCard;
